<!--
bellow is the table  -->

<div class="container-fluid pagecard employee-main" id="employee-list-page">
  <learn-more [title]="'Users (Support)' | translate | async"
    link="https://support.eatos.com/en-us/article/dashboard-employee-employees-2abmd3/"
    [content]="'Search users by entering their email, username, or support pin in the search field.' | translate | async"></learn-more>

  <div class="gross-tabs-sec border-bottom position-relative" style="z-index: 900">
    <!-- <nav ngbNav #nav="ngbNav" class="nav-tabs gross_tabs" [(activeId)]="active"> -->
    <!-- <ng-container [ngbNavItem]="1"> -->
    <!-- <a ngbNavLink> {{ 'Active' | translate | async }}</a> -->
    <!-- <ng-template ngbNavContent> -->
    <!-- empty list UI -->
    <div class="empty-courses" *ngIf="isEmpty">
      <div class="text-center">
        <img src="assets\images\Employees.svg" class="mb-2" />
        <h2 class="fw-600 mb-4">{{ 'Employees' | translate | async }}</h2>
        <p class="f-16 mb-5"> {{ 'No Employees Data Present' | translate | async }}</p>
        <!-- <button accessControl module="Employee" access="3" class="create-btn" (click)="goToAddPage()">
                {{ 'Create Employee(s)' | translate | async }}
              </button> -->
      </div>
    </div>

    <!--  table UI -->
    <div *ngIf="!isEmpty" [ngClass]="isEmpty ? 'isEmpty' : ''" class="position-relative" style="margin-top: -15px">
      <div class="table-responsive employees-table2 archive-data">
        <table id="employees-table" class="display table-make-responsive" cellspacing="0" width="100%" datatable
          [dtOptions]="dtOptions">
          <thead class="make-table-resp" style="border-top: 1px solid #6666;">
            <tr>
              <th class="emp-resize-name"> {{ 'Name' | translate | async }}</th>
              <th class="text-center"> {{ 'Store Name' | translate | async }}</th>
              <th class="text-center"> {{ 'Email' | translate | async }}</th>
              <th class="text-center"> {{ 'Mobile Number' | translate | async }}</th>
              <th class="text-center"> {{ 'Support Pin' | translate | async }}</th>
              <th class="text-center status-data"> {{ 'Date Created' | translate | async }}</th>
              <th class="text-center status-data"> {{ 'Login Session' | translate | async }}</th>
            </tr>
          </thead>
          <tbody class="fw-500">
            <!-- <ng-container>

                  </ng-container> -->
            <tr *ngFor="let employee of employees; let i = index" class="table-row">
              <td style="
                        width: fit-content !important;
                        overflow: hidden !important;
                        white-space: nowrap !important;
                        text-overflow: ellipsis !important;
                      ">
                <!-- <td> -->
                <div class="d-flex align-items-center align-self-center">
                  <span class="me-3 cate-tag">
                    <span *ngIf="!employee.employeeImage" style="
                              display: flex !important;
                              justify-content: center;
                              align-items: center;
                              width: 27.5px !important;
                              height: 27.5px !important;
                              border-radius: 50% !important;
                              font-weight: 700 !important;
                            ">
                      {{ employee.char }}
                    </span>
                    <img style="
                              width: 27.5px;
                              height: 27.5px;
                              border-radius: 50%;
                            " *ngIf="employee.employeeImage" [src]="'https://' + employee.employeeImage" [alt]="
                              employee?.employeeFirstName +
                              ' ' +
                              employee?.employeeFirstName
                            " />
                  </span>
                  <div class="text-left text-ellips employee-name" style="position: relative;"
                    (mouseenter)="employeeNameMouseEnter($event)">
                    <span class="fw-600">
                      {{ employee?.employeeFirstName }}
                      {{ employee?.employeeLastName }} <br />

                      <!-- <span class="f-11 text-muter fw-400 text-left">
                              {{ employee?.employeeRoleId?.roleName | translate | async}}
                            </span> -->
                    </span>
                    <div class="employee-tooltip">
                      {{ employee?.employeeFirstName }}
                      {{ employee?.employeeLastName }}
                    </div>
                  </div>
                </div>
              </td>
              <td style="
              font-size: 14px;
              color: #000000;
              width: fit-content !important;
              overflow: hidden !important;
              white-space: nowrap !important;
              text-overflow: ellipsis !important;
            ">
           {{ employee.storeId ? getStoreName(employee.storeId) : 'No storeId Available' }}
           </td>
              <td style="
                        font-size: 14px;
                        color: #000000;
                        width: fit-content !important;
                        overflow: hidden !important;
                        white-space: nowrap !important;
                        text-overflow: ellipsis !important;
                      ">
                {{ employee.employeeEmail ? employee.employeeEmail : 'No Email Available' }}
              </td>
              <td style="
                    width: fit-content !important;
                    overflow: hidden !important;
                    white-space: nowrap !important;
                    text-overflow: ellipsis !important;
                  ">
                {{ employee.employeeMobile ? employee.employeeMobile : 'No Mobile Available' | translate | async}}
              </td>
              <td style="
                    width: fit-content !important;
                    overflow: hidden !important;
                    white-space: nowrap !important;
                    text-overflow: ellipsis !important;
                  ">
                {{ employee.supportPin ? employee.supportPin : 'No Support Pin Available' | translate | async}}
              </td>
              <td class="text-center">
                <div>
                  {{ _convertDate(employee.employeeId, employee.createdAt) | translate | async }}
                </div>
              </td>
              <td>
                <div class="hidden-menu">
                  <ng-container *ngIf="employee.lastSession; else noSession">
                    {{ convertDate(employee.lastSession) | translate | async }} ;
                    {{ convertTime(employee.lastSession) | translate | async}}
                  </ng-container>
                  <ng-template #noSession>No Session Details Available</ng-template>
                </div>

                <div class="hover-menu">
                  <button accessControl module="Users" access="3" class="tooltip-custom" (click)="openPasswordModal(employee.employeeId, changePassword)">
                    <img src="../../../assets/images/key.svg" alt="password" style="filter: brightness(0) invert(0);" />
                    <div class="cust-tool">{{ 'Change Password' | translate | async }}</div>
                  </button>
                  <button accessControl module="Users" access="3" class="tooltip-custom" (click)="reset2fa(employee.employeeId, reset2faContent);
                        $event.stopPropagation()">
                    <img src="../../../assets/images/restart.svg" alt="edit" />
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-diamond" viewBox="0 0 16 16">
                            <path d="M7.987 16a1.53 1.53 0 0 1-1.07-.448L.45 9.082a1.53 1.53 0 0 1 0-2.165L6.917.45a1.53 1.53 0 0 1 2.166 0l6.469 6.468A1.53 1.53 0 0 1 16 8.013a1.53 1.53 0 0 1-.448 1.07l-6.47 6.469A1.53 1.53 0 0 1 7.988 16zM7.639 1.17 4.766 4.044 8 7.278l3.234-3.234L8.361 1.17a.51.51 0 0 0-.722 0M8.722 8l3.234 3.234 2.873-2.873c.2-.2.2-.523 0-.722l-2.873-2.873zM8 8.722l-3.234 3.234 2.873 2.873c.2.2.523.2.722 0l2.873-2.873zM7.278 8 4.044 4.766 1.17 7.639a.51.51 0 0 0 0 .722l2.874 2.873z"/>
                          </svg> -->
                    <div class="cust-tool">{{ 'Reset 2FA' | translate | async }}</div>
                  </button>
                  <!-- <button accessControl module="Users" access="3" ngbDropdownItem (click)=" openModal(content, employee)">
                          Open
                      </button> -->
                  <button accessControl module="Users" access="3" class="tooltip-custom"
                  (click)="openModal(content, employee);
                        $event.stopPropagation()">
                     <!-- <i class="bx bxs-notepad" style="font-size: large;"></i> -->
                     <img src="../../../assets/images/openticket.svg" alt="ticket" />
                    <!-- <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-diamond" viewBox="0 0 16 16">
                            <path d="M7.987 16a1.53 1.53 0 0 1-1.07-.448L.45 9.082a1.53 1.53 0 0 1 0-2.165L6.917.45a1.53 1.53 0 0 1 2.166 0l6.469 6.468A1.53 1.53 0 0 1 16 8.013a1.53 1.53 0 0 1-.448 1.07l-6.47 6.469A1.53 1.53 0 0 1 7.988 16zM7.639 1.17 4.766 4.044 8 7.278l3.234-3.234L8.361 1.17a.51.51 0 0 0-.722 0M8.722 8l3.234 3.234 2.873-2.873c.2-.2.2-.523 0-.722l-2.873-2.873zM8 8.722l-3.234 3.234 2.873 2.873c.2.2.523.2.722 0l2.873-2.873zM7.278 8 4.044 4.766 1.17 7.639a.51.51 0 0 0 0 .722l2.874 2.873z"/>
                          </svg> -->
                    <div class="cust-tool">{{ 'Open Ticket' | translate | async }}</div>
                  </button>

                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- </ng-template> -->
    <!-- </ng-container> -->

    <!-- <ng-container [ngbNavItem]="2" *ngIf="permissionService.canAccess('Employee', 3)">
        <a ngbNavLink routerLink="/employees/employeelist/archived">{{'Archived' | translate | async }}</a>
      </ng-container> -->
    <!-- </nav> -->

    <!-- <div class="position-absolute employee-new-listbtn">
      <div class="d-flex gap-2 employee-all-btn">
        <div (click)="dateInput.showPicker()">
          <input type="date" (change)="select($event)" [value]="today" class="form-control f-12" style="padding: 9px"
            #dateInput />
        </div>
       <div class="d-flex gap-1 align-items-center">
        <button
        accessControl
        module="Employee"
        access="3"
        class="new-btn"
        (click)="goToAddPage()"
        type="button"
      >
        <span class="pe-13">
          <img src="assets\images\plusIcon.svg" />
        </span>
       {{' New Employee' | translate | async }}
        </button>
        <div style="
            display: flex !important;
            justify-content: center !important;
            align-items: center !important;
          ">
          <div ngbDropdown container="body">
            <div class="cursor-pointer" ngbDropdownToggle>
              <i class="fas fa-ellipsis-v"></i>
            </div>
            <div ngbDropdownMenu class="p-2" style="margin-top: 10px !important">
              <a class="cursor-pointer" ngbDropdownItem (click)="exportEmployee()">
                {{'Export Employee Data' | translate | async }}
              </a>
            </div>
          </div>
        </div>
       </div>
      </div>
    </div> -->
  </div>

  <!-- <div [ngbNavOutlet]="nav" class="mt-2"></div> -->
</div>

<!-- MODAL -->
<ng-template #content let-offcanvas>
  <div style="overflow: auto;">
    <div>
      <!-- Show Loader -->
      <div *ngIf="loaderState" class="editproduct-main"
        style="position: relative; height: 962px; display: flex; justify-content: center; align-items: center;">
        <div class="loader-content-overlay">
          <img alt="img" src="../../../../../assets//images/loaders/eatos_loading_0-Black.gif" width="190"
            height="190" />
        </div>
      </div>
    </div>
    <!-- Show History -->
    <div *ngIf="!loaderState" class="offcanvas-body">
      <div class="d-flex justify-content-between mb-4 gap-4">
        <div class="f-30 fw-700 text-black paid_text text-uppercase">
          {{ employeeDetails.employeeCompleteName.toUpperCase() }}
        </div>
        <div style="display: flex; justify-content: end;" class="align-self-center">
          <button type="button" class="btn-close f-14 p-0 btn-details" aria-label="Close" (click)="
              closeModal(content); offcanvasService.dismiss('Cross click')
            "></button>
        </div>
      </div>

      <div class="bill-details h-100 d-flex flex-column h-100">
        <ng-container>
          <div>
            <!-- Employee Details -->
            <div class="f-16 fw-500 receipt-num">
              <div class="d-flex justify-content-between mb-2">
                <div *ngIf="employeeDetails.employeeEmail">
                  {{ "Employee Email" }} :<b> {{ employeeDetails.employeeEmail }}</b>
                </div>
                <div *ngIf="!employeeDetails.employeeEmail">
                  {{ "Employee Email" }} :<b> No Email Available </b>
                </div>
                <div *ngIf="employeeDetails.createdAt == 0">---------</div>
                <div *ngIf="employeeDetails.createdAt != 0" class="text-uppercase">
                  {{
                  _convertDate(employeeDetails.employeeId, employeeDetails.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div class="d-flex justify-content-between mb-2">
                <div *ngIf="employeeDetails.employeeMobile">
                  {{ "Employee Mobile" }} :<b> {{ employeeDetails.employeeMobile }}</b>
                </div>
                <div *ngIf="!employeeDetails.employeeMobile">
                  {{ "Employee Mobile" }} :<b> No Mobile Available </b>
                </div>
                <div *ngIf="employeeDetails.createdAt == 0">---------</div>
                <div *ngIf="employeeDetails.createdAt != 0" class="text-uppercase">
                  {{
                  _convertTime(employeeDetails.employeeId, employeeDetails.createdAt) | translate | async
                  }}
                </div>
              </div>
              <div *ngIf="employeeDetails?.supportPin" class="mb-2">
                {{ "Support Pin :" | translate | async }}
                <b>{{ employeeDetails?.supportPin }}</b>
                <!-- <i
                    class="fas fa-sync-alt m-1 cs-pointer"
                    (click)="generateSupportPin()"
                  ></i> -->
              </div>
              <div *ngIf="!employeeDetails?.supportPin" class="mb-2">
                {{ "Support pin :" | translate | async }}
                <b> No Support Pin Available </b>
              </div>
            </div>
            <!-- Order History Table -->
            <div class="card">
              <div class="card-body">
                <div class="d-flex align-items-center mb-3" style="justify-content: space-between;">
                  <div class="f-14 fw-600 me-3">{{ 'Employee Order History' | translate | async }}</div>
                  <button class="btn btn-primary" (click)="fetchEmployeeOrderHistory()"
                    style="background-color: black; color: white; padding: revert;">
                    <i class="fas fa-sync-alt m-1 cs-pointer"></i>
                    {{ 'Fetch Orders' | translate | async }}
                  </button>
                </div>
                <div class="overflow-auto">
                  <table class="w-100 normal_table" style="line-height: 35px !important;">
                    <tr class="thead_bg">
                      <th class="fw-600 f-14">{{'Date Created' | translate | async}}</th>
                      <!-- <th class="fw-600 f-14">{{'Time' | translate | async}}</th> -->
                      <th class="fw-600 f-14">{{'Order Number' | translate | async}}</th>
                      <th class="fw-600 f-14">{{'Order Type' | translate | async}}</th>
                      <th class="fw-600 f-14 text-start">{{'Amount' | translate | async}}</th>
                      <!-- <th></th> -->
                    </tr>
                    <tbody>
                      <tr *ngIf="!employeeOrderHistory.length">
                        <td colspan="5" class="fw-600 f-14 text-center">
                          {{'No available orders' | translate | async}}
                        </td>
                      </tr>
                      <ng-container *ngFor="let order of employeeOrderHistory; let x = index">
                        <!-- (click)="seePaymentReceipt(content, order, x)" -->
                        <tr *ngIf="employeeOrderHistory.length" data-bs-toggle="offcanvas"
                          data-bs-target="#viewOrderModal" aria-controls="viewOrderModal">
                          <td class="text-start">
                            {{ _convertDate(order.orderId, order.createdAt) }}<br />
                            <!-- <span style="display: flex; justify-content: center;">
                              {{ __convertTime(order.orderId, order.createdAt) | translate | async }}
                            </span> -->
                          </td>
                          <!-- <td class="text-start">{{ _convertTime(order.orderId, order.createdAt) | translate | async }}</td> -->
                          <td style="display: flex; justify-content: center;">#{{ order.orderNumber | translate | async
                            }}</td>
                          <td>
                            {{ orderTypeText(order.orderType) | translate | async }}
                          </td>
                          <td class="text-start">
                            {{ order.actualPaidAmount | currency : currency : "symbol" | translate | async}}
                          </td>
                        </tr>
                      </ng-container>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Issue Details -->
        <ng-container>
          <!-- I want to Add a Section that Provides a Description Area i.e Text Area where the issue can be described -->
          <!-- Below the Description Area there should be a button to Create Issue  -->
          <!-- Below the buutn there Should be a List of All Issues Created till now i.e Issue Description and Status -->
          <div class="align-center-wrapper">
            <div class="mb-3 row d-flex">
              <div class="form-label col-sm-3 f-16 fw-500" style="padding-top: 10px;">Issue Title*:</div>
              <div class="col-sm-9">
                <input type="text" id="title" class="form-control" [(ngModel)]="issueTitle"
                  placeholder="Enter issue title">
              </div>
            </div>
            <!-- <div class="mb-3 row d-flex">
          <div class="form-label col-sm-4">Description*:</div>
          <div class="col-sm-8">
            <textarea id="description" class="form-control" rows="3" [(ngModel)]="issueDescription" placeholder="Describe the issue"></textarea>
          </div>
        </div> -->
            <ckeditor [editor]="Editor" (ready)="onReady($event)" tagName="textarea" [(ngModel)]="editorContent"
              id="classic-editor" name="classic-editor" (change)="onChange($event)" (focus)="onFocus($event)"
              (blur)="onBlur($event)" [config]="{
              placeholder: 'Please Describe the Issue...',
              toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|', 'blockQuote', '|', 'undo', 'redo']
            }">
            </ckeditor>
            <ngx-dropzone (change)="onFilesAdded($event)"
              style="height:162px; border:1px dashed; width:548px; margin-top: 10px;"
              [accept]="'image/*,video/*,.xls,.xlsx'">
              <ngx-dropzone-label>
                <div class="d-flex flex-column justify-content-center align-items-center">
                  <img src="../../../../assets/images/uplode-menu.png" class="mb-3" style="width: 50px" />
                  <div class="fs-6 text-dark fw-bold">
                    <p class="mb-0 fw-500">{{ "Drop files here or click to upload" | translate | async }}</p>
                  </div>
                </div>
              </ngx-dropzone-label>
              <ngx-dropzone-preview *ngFor="let f of files" [removable]="true" (removed)="onRemoveFile(f)">
                <ngx-dropzone-label>{{ f.name }}</ngx-dropzone-label>
              </ngx-dropzone-preview>
            </ngx-dropzone>
            <div>
              <button (click)="createIssue()" style="margin-top: 20px;" class="submit-btn f-16 fw-600 pointer">
                {{ "Create Ticket" | translate | async }}
              </button>
            </div>
            <!-- <div class="w-100 sales-main">
          <div class="improve-all"> -->
            <!-- <textarea
            style="border-radius: 5px;"
              placeholder="Describe the Issue"
              class="f-16 fw-500 improve-details w-100 improve-width"
              [(ngModel)]="issueDescription"
            ></textarea> -->
            <!-- <ckeditor
              [editor]="Editor"
              [config]="ckconfig"
              tagName="textarea"
              [(ngModel)]="editorContent"
              id="classic-editor"
	            name="classic-editor"
            	(change)="onChange($event)"
	            (focus)="onFocus($event)"
	            (blur)="onBlur($event)"
            ></ckeditor> -->

            <!-- [config]="{
            placeholder: 'Please Describe the Issue...',
            toolbar: ['heading', '|', 'bold', 'italic', 'link', '|', 'bulletedList', 'numberedList', '|',
            'imageUpload', 'blockQuote', '|', 'undo', 'redo', '|',
            'mediaEmbed', '|',
            'insertTable',]
             }" -->

            <!-- </div>

        </div> -->

            <!-- EMPLOYEE ISSUES LIST -->
            <!-- <div class="card">
  <div class="card-body">
    <div class="f-14 mb-3 fw-600">{{'Employee Issues List' | translate | async}}</div>
    <div class="overflow-auto">
      <table class="w-100 normal_table" style="line-height: 35px !important;">
        <tr class="thead_bg">
          <th class="fw-600 f-14">{{'Date Created' | translate | async}}</th>
          <th class="fw-600 f-14">{{'Issue Description' | translate | async}}</th>
          <th class="fw-600 f-14 text-start">{{'Status' | translate | async}}</th>
        </tr>
        <tbody>
          <tr *ngIf="!employeeOrderHistory.length">
            <td colspan="5" class="fw-600 f-14 text-center">
              {{'No available Issues' | translate | async}}
            </td>
          </tr>
          <ng-container *ngFor="let order of employeeOrderHistory; let x = index">
            <tr *ngIf="employeeOrderHistory.length"
              data-bs-toggle="offcanvas"
              data-bs-target="#viewOrderModal"
              aria-controls="viewOrderModal"
            >
              <td class="text-start">
                {{ _convertDate(order.orderId, order.createdAt) }}<br />
              </td>
              <td style="display: flex; justify-content: center;">#{{ order.orderNumber | translate | async }}</td>
              <td class="text-start">
                {{ order.actualPaidAmount | currency : currency : "symbol" | translate | async}}
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </div>
</div> -->
          </div>
        </ng-container>
      </div>
    </div>

  </div>

</ng-template>

<!-- Reset Modal -->
<ng-template #reset2faContent role="document" let-modal>
  <div class="modal-body border-0">
    <div class="delete-icon-info">
      <div class="swal2-icon swal2-warning swal2-icon-show" style="display: flex; animation: none !important">
        <div class="swal2-icon-content">!</div>
      </div>
      <h2 class="swal2-title" id="swal2-title" style="display: flex; text-align: center;">
        {{ 'Are you sure you want to reset the 2FA settings?' | translate | async }}
      </h2>
    </div>
  </div>
  <div class="modal-footer border-0">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-12 text-center">
          <button class="btn add-btn-one fw-bold mt-2" (click)="resetEmployee(reset2faId, reset2faContent)">
            {{'Yes, reset it!' | translate | async }}
          </button>
          <button class="btn btn-dark add-btn-two fw-bold mt-2" style="margin-left: 15px"
            (click)="cancelDelete(reset2faContent)">
            {{'Cancel' | translate | async }}
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #changePassword let-modal>
  <div class="modal-body">
    <div class="d-flex justify-content-between mb-2">
      <div class="f-20 fw-600">{{ 'Change Password' | translate | async }}</div>
      <div>
        <img style="padding: 5px; cursor: pointer" src="assets/images/closeIcon.svg"
          (click)="closeModal(changePassword)" />
      </div>
    </div>
    <div class="f-14 fw-500 mb-3">
      <span>{{ 'Enter your new password below.' | translate | async }}</span>
    </div>

    <div class="mb-3">
      <label for="password" class="form-label">{{ 'New Password*' | translate | async }}</label>
      <div class="input-group auth-pass-inputgroup">
        <input [type]="isShowPassword ? 'text' : 'password'" class="form-control" id="password"
          placeholder="Enter New Password" [(ngModel)]="newPassword" name="newPassword"
          pattern="(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,32}" required />

        <button class="btn btn-light ms-0 eyebtn ml-1" type="button" (click)="showPassword()">
          <i *ngIf="!isShowPassword" class="fa-light fa-eye"></i>
          <i *ngIf="isShowPassword" class="fa-light fa-eye-slash"></i>
        </button>
        <div class="form-text text-danger" *ngIf="passwordError">
          {{ passwordError }}
        </div>
      </div>
      <div class="f-17 fw-450 mt-2">{{ 'Password Instructions' | translate | async }}</div>
      <ul>
        <li>{{ 'Password must be 8 to 32 characters long.' | translate | async }}</li>
        <li>{{ 'Contain at least one number and one uppercase.' | translate | async }}</li>
        <li>{{ 'One lowercase letter and one special character.' | translate | async }}</li>
      </ul>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        <button class="primary_btn f-18 w-100 fw-700 text-white" (click)="changePasswordSubmit()">
          <span *ngIf="isLoading">
            <span class="spinner-grow spinner-grow-sm" role="status"></span>
            &nbsp;&nbsp;{{ 'Please wait...' | translate | async }}
          </span>
          <span *ngIf="!isLoading">
            {{ 'Change Password' | translate | async }}
          </span>
        </button>
      </div>
    </div>
  </div>
</ng-template>